import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		options: {
			customProperties: true,
		},
		themes: {
			light: {
				primary: "#0f0f16",
				secondary: "#292931",
				accent: "#bfaa7f", // #7f94bf #d4af37 #bfaa7f #005cb8 #0da2ff #0a86cc #c6aa6f
				success: "#6fae5e",
				warning: "#F3984E",
				error: "#df554b",
				info: "#2981c9",
			},
			dark: {
				primary: "#0f0f16",
				secondary: "#292931",
				accent: "#bfaa7f",
			},
		},
	},
});
